import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import PropTypes from 'prop-types';

import axios from 'axios';
import { db } from 'firebase/fbConfig.js';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';

// @material-ui/icons
import Face from '@material-ui/icons/Face';
import Email from '@material-ui/icons/Email';
import SendIcon from '@material-ui/icons/Send';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import ChatInput from 'components/CustomInput/ChatInput.jsx';
import Button from 'components/CustomButtons/Button.jsx';

import styles from 'assets/jss/material-dashboard-pro-react/components/CreateMessageFormStyle.jsx';

import { startAddMessage } from 'store/actions/threadsActions';
import { openFileUploadDialog } from 'store/actions/navigationActions';
import AddCircleIcon from '@material-ui/icons/AddCircle';

class Form extends React.Component {
  state = {
    sending: false,
    messageError: false,
  };
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: 'cardHidden',
    };
    this.messageRef = React.createRef();
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: '' });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { uid, user, currentThread, users } = this.props;



    //  THIS MAY BE SLOWING DOWN APPLICATION, PERFORMING THIS SO THAT NOTIFICATIONS CAN SHOW FIRST, LAST AND EMAIL

    var nameInfo = { email: user.email }
    for (var x = 0; x < users.length; x++) {
      if (users[x].uid === uid) {
        nameInfo.firstName = users[x].firstName
        nameInfo.lastName = users[x].lastName
      }
    }

    currentThread.parties.map((partyID) => {
      // console.log('user!!!!!!!!', user);
      db.collection('users').doc(partyID).collection('notifications').add({
        createdAt: new Date(),
        description: 'New Message',
        threadName: currentThread.name,
        cid: currentThread.cid,
        tid: currentThread.tid,
        status: 'new',
        from: nameInfo,
        type: 'newMessage',
      });
    });
    console.log('hello');
    this.setState({ ...this.state, sending: true });
    this.props
      .startAddMessage(currentThread.tid, {
        uid,
        message: this.messageRef.current.value,
        from: nameInfo,
        tid: currentThread.tid,
        cid: currentThread.cid,
        name: currentThread.name,
      })
      .then(
        () => {
          this.setState((state) => ({ ...state, sending: false }));
          this.messageRef.current.value = '';
        },
        (messageError) =>
          this.setState((state) => ({ ...state, messageError, sending: false }))
      );
  };

  render() {
    const { classes, openUploadDialog } = this.props;
    //console.log(uid + " " + id)
    // reset modal when closed
    //if (this.state.messageSent) { this.resetRequest() }
    //console.log(this.state)
    return (
      <div>
        <div
          className={classes.formContainer + ' ' + classes.chatTray}
          justify="center"
        >
          <form onSubmit={this.handleSubmit}>
            <AddCircleIcon onClick={() => openUploadDialog()} className={classes.uploadBtn} style={{ width: '40px', height: '40px', color: '#0EB2D8', fontSize: 'large' }}></AddCircleIcon>
            <GridContainer>
              <GridItem xs={9}>
                {this.state.messageError ? (
                  <h5 className={classes.bodyText}>There Has Been An Error</h5>
                ) : null}
                <br />
                <ChatInput
                  labelText="Type Something..."
                  id="message"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    required: true,
                    type: 'text',
                    multiline: false,
                    rows: 1,
                  }}
                  inputRef={this.messageRef}
                />
              </GridItem>
              <GridItem xs={1}>
                <Button
                  type="submit"
                  color="primary"
                  className={classes.sendBtn}
                >
                  <SendIcon></SendIcon>
                </Button>
              </GridItem>
            </GridContainer>
          </form>
        </div>
      </div>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    startAddMessage: (id, message) => dispatch(startAddMessage(id, message)),
    openUploadDialog: () => dispatch(openFileUploadDialog()),
  };
};

const mapStateToProps = (state) => {
  console.log('state', state)
  return {
    uid: state.auth.user.uid,
    user: state.auth.user,
    currentThread: state.threads.currentThread,
    users: state.user.users.dataRows
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(Form);
